import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CREATE_CARRIER_RESPONSIBLE_EMAIL_" }
);

export interface CreateCarrierResponsibleEmailState extends IState {}

const INITIAL_STATE: CreateCarrierResponsibleEmailState = {
  loading: false,
  error: null,
};

const request = (state: CreateCarrierResponsibleEmailState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: CreateCarrierResponsibleEmailState,
  action: ISuccessAction
) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: CreateCarrierResponsibleEmailState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const createCarrierResponsibleEmail = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CreateCarrierResponsibleEmailTypes = Types;
export const CreateCarrierResponsibleEmailActions = Creators;
